import { store } from '@betacrew/jars-flux'
export const componentKey = "W8W9REQUEST";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setRequests : (state, action) => {
            state.requests = action.payload;
        },
        setSkip : (state, action) => {
            state.skip = action.payload;
        },
        setRowsPerPage : (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setTotalRequests: (state, action) => {
            state.totalRequests = action.payload;
        },
        setIsMemberUserAccessPrePayEnabled: (state, action) => {
            state.isMemberUserAccessPrePayEnabled = action.payload;
        },
        setShowPopupPrepayRequest: (state, action) => {
            state.showPopupPrepayRequest = action.payload;
        },
        setShowPopupPaymentOptions: (state, action) => {
            state.showPopupPaymentOptions = action.payload;
        },
        setPopupPaymentOptions: (state, action) => {
            state.popupPaymentOptions = action.payload;
        },
        setSelectedPopupPaymentOptions: (state, action) => {
            state.selectedPopupPaymentOptions = action.payload;
        },
    },
    initialReducerState: {
        requests: [],
        totalRequests: 0,
        rowsPerPage: 10,
        skip: 0,
        loadingState: false,
        isMemberUserAccessPrePayEnabled: false,
        showPopupPrepayRequest: false,
        showPopupPaymentOptions: false,
        popupPaymentOptions: [],
        selectedPopupPaymentOptions: {value: "", label: ""}
    }
});
export const { setRequests, setSkip, setRowsPerPage, setLoadingState, setTotalRequests, setIsMemberUserAccessPrePayEnabled, setShowPopupPrepayRequest, setShowPopupPaymentOptions, setPopupPaymentOptions, setSelectedPopupPaymentOptions } = actions;